export default "__VITE_ASSET__ByhY$Kqr__"